import styled from 'styled-components';

export const SocialBar = styled.div`
  position: -webkit-sticky;
  position: sticky;
  background: #ff7300;
  top: 0px;
  background-color: #fff;
  width: 35px;
  .st-custom-button[data-network] {
    padding: 5px;
    width: 35px;
    img {
      cursor: pointer;
    }
  }
`;

export const SocialBarMobile = styled.div`
  .st-custom-button[data-network] {
    display: inline-block;
    padding: 5px;
    vertical-align: middle;
    img {
      cursor: pointer;
    }
  }
  .title {
    font-size: 16px;
    color: #2f3034;
    line-height: 26px;
    margin-right: 20px;
  }
`;

export const BackToTopButton = styled.div` 
    background-color: #434447;
    opacity: 0.3;
    width: 38px;
    height: 38px;
    position: fixed;
    bottom: 10px;
    right: 10px;
    border-radius: 50px;
    border: none;
    cursor: pointer;
    :hover{
      opacity: 0.8;
    }
    text-align: center;
    .hui-icon-back {
      -ms-transform: rotate(90deg); 
      -webkit-transform: rotate(90deg); 
      transform: rotate(90deg);
      text-align: center;
      font-size: 16px;
      margin-top: 10px;
      color: #fff;
    };
  }
`;
